"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrivateRoute = exports.PrivateRouteComponent = void 0;
var React = __importStar(require("react"));
var loading_part_1 = require("../pages/parts/loading.part");
var use_track_page_1 = require("../../hooks/use-track-page");
var use_app_routes_1 = require("../../hooks/use-app-routes");
var app_section_context_1 = require("../context/app-section-context");
var entity_definition_context_1 = require("../context/entity-definition-context");
var router_1 = require("@reach/router");
var auth0_react_1 = require("@auth0/auth0-react");
var use_active_user_1 = require("../../hooks/use-active-user");
var application_context_1 = require("../context/application-context");
var client_1 = require("@apollo/client");
var use_app_state_1 = require("../../hooks/use-app-state");
var PrivateRouteComponent = function (props) {
  var user = (0, use_active_user_1.useActiveUser)();
  var _a = __read((0, use_app_state_1.useAppState)(), 2),
    appState = _a[0],
    setAppState = _a[1];
  var loading = user.loading,
    mustChangePassword = user.mustChangePassword,
    agreesToTerms = user.agreesToTerms,
    id = user.id,
    personId = user.personId,
    permissions = user.permissions;
  var client = (0, client_1.useApolloClient)();
  var activePersonQuery = React.useContext(application_context_1.ApplicationContext).activePersonQuery;
  React.useEffect(function () {
    if (user.personId && !appState.activePerson) {
      // console.log(user.person && user.person.id);
      var fetchPerson = function () {
        return __awaiter(void 0, void 0, void 0, function () {
          var response;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                setAppState(__assign(__assign({}, appState), {
                  activePerson: {
                    loading: true
                  }
                }));
                return [4 /*yield*/, client.query({
                  query: activePersonQuery,
                  variables: {
                    id: personId
                  }
                })];
              case 1:
                response = _a.sent();
                setAppState(__assign(__assign({}, appState), {
                  activePerson: {
                    loading: false,
                    permissions: permissions,
                    user: user,
                    person: response.data && response.data.person
                  }
                }));
                return [2 /*return*/];
            }
          });
        });
      };
      fetchPerson();
    }
  }, [loading, user, appState.activePerson]);
  // console.log(client.cache);
  if (process.env.PAGE_TRACKING === "true") {
    /*
    While this hook shouldn't be used in an if statement, the env value will not change,
    and it's wasteful to setup the lifecycle event if tracking is disabled
    */
    (0, use_track_page_1.useTrackPage)({
      pathname: props.location.pathname,
      options: {
        id: id
      }
    });
  }
  var routes = (0, use_app_routes_1.useAppRoutes)();
  if (loading) {
    return React.createElement(loading_part_1.LoadingPart, null);
  }
  // console.log("PRIVATE ROUTE PERSON", person, userId);
  if (!agreesToTerms) {
    (0, router_1.navigate)(routes.setupTerms);
    return null;
  }
  if (mustChangePassword) {
    (0, router_1.navigate)(routes.setupChangePassword);
    return null;
  }
  // we have a user object, but perhaps no person yet
  if (!appState.activePerson) {
    return React.createElement(loading_part_1.LoadingPart, null);
  }
  var Component = props.component;
  var appSection = props.appSection || props.definition && props.definition.appSection;
  var inner = React.createElement(Component, __assign({}, props));
  var withDefinition = props.definition ? React.createElement(entity_definition_context_1.EntityDefinitionProvider, {
    value: props.definition
  }, inner) : inner;
  return appSection ? React.createElement(app_section_context_1.AppSectionProvider, {
    value: {
      appSection: appSection,
      appSectionChild: props.appSectionChild
    }
  }, withDefinition) : withDefinition;
};
exports.PrivateRouteComponent = PrivateRouteComponent;
exports.PrivateRoute = (0, auth0_react_1.withAuthenticationRequired)(exports.PrivateRouteComponent, {
  onRedirecting: function () {
    return React.createElement(loading_part_1.LoadingPart, null);
  }
});